const API_URL = "https://agro-nexus-prod.vercel.app/api";

function authHeaders(isFormData = false) {
  const token = localStorage.getItem("token");
  return isFormData
    ? { Authorization: `Bearer ${token}` }
    : {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
}

export const api = {
  // ==================== AUTENTICACIÓN ====================
  login: async (email, password) => {
    const res = await fetch(`${API_URL}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });
    return res.json();
  },

  register: async (data) => {
    const res = await fetch(`${API_URL}/registro`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return res.json();
  },

  perfil: async () => {
    const res = await fetch(`${API_URL}/perfil`, { headers: authHeaders() });
    return res.json();
  },

  // ==================== TERRENOS ====================
  getTerrenos: async () => {
    const res = await fetch(`${API_URL}/terrenos`, { headers: authHeaders() });
    return res.json();
  },

  createTerreno: async (data) => {
    const res = await fetch(`${API_URL}/terrenos`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  addTerreno: async (data) => {
    const res = await fetch(`${API_URL}/terrenos`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  updateTerreno: async (id, data) => {
    const res = await fetch(`${API_URL}/terrenos/${id}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  deleteTerreno: async (id) => {
    const res = await fetch(`${API_URL}/terrenos/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    return res.json();
  },

  getMisTerrenos: async () => {
    const res = await fetch(`${API_URL}/mis-terrenos`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  getSensoresTerreno: async (terrenoId) => {
    const res = await fetch(`${API_URL}/terrenos/${terrenoId}/sensores`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  // ==================== MIEMBROS DE TERRENO ====================
  getTerrenoMiembros: async (terrenoId) => {
    const res = await fetch(`${API_URL}/terrenos/${terrenoId}/miembros`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  addTerrenoMiembro: async (terrenoId, data) => {
    const res = await fetch(`${API_URL}/terrenos/${terrenoId}/miembros`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  updateTerrenoMiembro: async (terrenoId, usuarioId, data) => {
    const res = await fetch(
      `${API_URL}/terrenos/${terrenoId}/miembros/${usuarioId}`,
      {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(data),
      }
    );
    return res.json();
  },

  deleteTerrenoMiembro: async (terrenoId, usuarioId) => {
    const res = await fetch(
      `${API_URL}/terrenos/${terrenoId}/miembros/${usuarioId}`,
      {
        method: "DELETE",
        headers: authHeaders(),
      }
    );
    return res.json();
  },

  // API alternativa para usuarios de terreno (misma funcionalidad)
  getUsuariosTerreno: async (terrenoId) => {
    const res = await fetch(`${API_URL}/terrenos/${terrenoId}/usuarios`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  addUsuarioTerreno: async (terrenoId, data) => {
    const res = await fetch(`${API_URL}/terrenos/${terrenoId}/usuarios`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  updateUsuarioTerreno: async (terrenoId, usuarioId, data) => {
    const res = await fetch(
      `${API_URL}/terrenos/${terrenoId}/usuarios/${usuarioId}`,
      {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify(data),
      }
    );
    return res.json();
  },

  removeUsuarioTerreno: async (terrenoId, usuarioId) => {
    const res = await fetch(
      `${API_URL}/terrenos/${terrenoId}/usuarios/${usuarioId}`,
      {
        method: "DELETE",
        headers: authHeaders(),
      }
    );
    return res.json();
  },

  // ==================== BÚSQUEDA DE USUARIOS ====================
  buscarUsuarios: async (query) => {
    try {
      console.log("🔍 Buscando usuarios con query:", query);
      const res = await fetch(
        `${API_URL}/usuarios/buscar?q=${encodeURIComponent(query)}`,
        { headers: authHeaders() }
      );
      const data = await res.json();
      console.log("📥 Respuesta búsqueda usuarios:", data);
      return data;
    } catch (error) {
      console.error("❌ Error en buscarUsuarios:", error);
      return { success: false, usuarios: [] };
    }
  },

  searchUsuarios: async (query) => {
    try {
      console.log("🔍 Buscando usuarios con query:", query);
      const res = await fetch(
        `${API_URL}/usuarios/buscar?q=${encodeURIComponent(query)}`,
        { headers: authHeaders() }
      );
      const data = await res.json();
      console.log("📥 Respuesta búsqueda usuarios:", data);
      return data;
    } catch (error) {
      console.error("❌ Error en searchUsuarios:", error);
      return { success: false, usuarios: [] };
    }
  },

  // ==================== GRUPOS ====================
  getGrupos: async () => {
    const res = await fetch(`${API_URL}/grupos`, { headers: authHeaders() });
    return res.json();
  },

  addGrupo: async (data) => {
    const res = await fetch(`${API_URL}/grupos`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  updateGrupo: async (id, data) => {
    const res = await fetch(`${API_URL}/grupos/${id}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  deleteGrupo: async (id) => {
    const res = await fetch(`${API_URL}/grupos/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    return res.json();
  },

  getGrupoMiembros: async (grupoId) => {
    const res = await fetch(`${API_URL}/grupos/${grupoId}/miembros`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  addMiembroGrupo: async (id, usuario_id, rol) => {
    const res = await fetch(`${API_URL}/grupos/${id}/miembros`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ usuario_id, rol }),
    });
    return res.json();
  },

  updateMiembroGrupo: async (id, usuarioId, rol) => {
    const res = await fetch(`${API_URL}/grupos/${id}/miembros/${usuarioId}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({ rol }),
    });
    return res.json();
  },

  deleteMiembroGrupo: async (id, usuarioId) => {
    const res = await fetch(`${API_URL}/grupos/${id}/miembros/${usuarioId}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    return res.json();
  },

  getGrupoTerrenos: async (grupoId) => {
    const res = await fetch(`${API_URL}/grupos/${grupoId}/terrenos`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  addGrupoTerreno: async (grupoId, data) => {
    const res = await fetch(`${API_URL}/grupos/${grupoId}/terrenos`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  deleteGrupoTerreno: async (grupoId, terrenoId) => {
    const res = await fetch(
      `${API_URL}/grupos/${grupoId}/terrenos/${terrenoId}`,
      {
        method: "DELETE",
        headers: authHeaders(),
      }
    );
    return res.json();
  },

  // ==================== CHATS ====================
  getChats: async () => {
    const res = await fetch(`${API_URL}/chats`, { headers: authHeaders() });
    return res.json();
  },

  crearChat: async (data) => {
    const res = await fetch(`${API_URL}/chats`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  getMensajes: async (id) => {
    const res = await fetch(`${API_URL}/chats/${id}/mensajes`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  sendMensaje: async (id, contenido) => {
    const res = await fetch(`${API_URL}/chats/${id}/mensajes`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ contenido }),
    });
    return res.json();
  },

  sendArchivoMensaje: async (id, file) => {
    const formData = new FormData();
    formData.append("archivo", file);

    const res = await fetch(`${API_URL}/chats/${id}/mensajes/archivo`, {
      method: "POST",
      headers: authHeaders(true),
      body: formData,
    });
    return res.json();
  },

  // ==================== SENSORES ====================
  getSensores: async () => {
    const res = await fetch(`${API_URL}/sensores`, { headers: authHeaders() });
    return res.json();
  },

  getSensorDatos: async (id, params = {}) => {
    const query = new URLSearchParams(params).toString();
    const res = await fetch(`${API_URL}/sensores/${id}/datos?${query}`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  addSensor: async (data) => {
    const res = await fetch(`${API_URL}/sensores`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  updateSensor: async (id, data) => {
    const res = await fetch(`${API_URL}/sensores/${id}`, {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  deleteSensor: async (id) => {
    const res = await fetch(`${API_URL}/sensores/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    return res.json();
  },

  addDatoSensor: async (id, valor) => {
    const res = await fetch(`${API_URL}/sensores/${id}/datos`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify({ valor }),
    });
    return res.json();
  },

  getUsuarioSensoresDatos: async () => {
    const res = await fetch(`${API_URL}/usuario/sensores-datos`, {
      headers: authHeaders(),
    });
    return res.json();
  },

  // ==================== AGENDA ====================
  getEventos: async () => {
    const res = await fetch(`${API_URL}/agenda`, { headers: authHeaders() });
    return res.json();
  },

  addEvento: async (data) => {
    const res = await fetch(`${API_URL}/agenda`, {
      method: "POST",
      headers: authHeaders(),
      body: JSON.stringify(data),
    });
    return res.json();
  },

  deleteEvento: async (id) => {
    const res = await fetch(`${API_URL}/agenda/${id}`, {
      method: "DELETE",
      headers: authHeaders(),
    });
    return res.json();
  },

  // ==================== ALERTAS ====================
  getAlertas: async (terrenoId = "", sensorId = "") => {
    const params = new URLSearchParams();
    if (terrenoId) params.append("terrenoId", terrenoId);
    if (sensorId) params.append("sensorId", sensorId);

    const res = await fetch(`${API_URL}/alertas?${params.toString()}`, {
      headers: authHeaders(),
    });
    return res.json();
  },
};
